// extracted by mini-css-extract-plugin
export default {"diagonalBackground":"Projects_diagonalBackground__BHpc1"};